
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class Course extends Vue {
  @Prop({ required: true }) private list!: any;
  @Prop({ required: true }) private blmCourseList!: any;
  @Prop({ required: true }) private courseType!: any;
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/798bf57dd811d25cd3be074bcd86ca20.png";
  pic2 = "/img/b72d2f0801b1717b4ab6bb4f505ebc9a.png";
  pic3 = "/img/e10e6371071e3af169368010b00b32f9.png";
  pic4 = "/img/db47f30b14a9cd5b0501381c739b2c2e.png";
  pic5 = "/img/dcd2ef5bb566a3857d66e3b985e1a30d.png";
  pic6 = "/img/3e49c22e8a818915dae656c4ef5f7f86.png";
  // 点击切换
  handleBtn(key: any) {
    this.$emit("changeCourse", key);
  }
  // 点击更多
  handleMore() {
    this.$router.push(`/course?type=${this.courseType}`);
  }

  toUrl(index: any) {
    if (index == 1) {
      this.$router.push(`/growth-camp`);
    } else if (index == 2) {
      this.$router.push(`/emba`);
    } else if (index == 3) {
      this.$router.push(`/research-institute`);
    } else if (index == 4) {
      this.$router.push(`/digital-running-companion`);
    } else if (index == 5) {
      this.$router.push(`/business-school`);
    } else if (index == 6) {
      this.$router.push(`/accompany?tab=0`);
    }
  }
}
